import { render, staticRenderFns } from "./CenterBottomStats.vue?vue&type=template&id=ae9233bc&scoped=true"
import script from "./CenterBottomStats.vue?vue&type=script&lang=js"
export * from "./CenterBottomStats.vue?vue&type=script&lang=js"
import style0 from "./CenterBottomStats.vue?vue&type=style&index=0&id=ae9233bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9233bc",
  null
  
)

export default component.exports